// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

//Element
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI)

//全局样式
import './assets/css/global-style.css'
import './assets/less/main.less'

//图片查看器
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

//diy icon
import './assets/css/diy-icon/iconfont.css'

//vuex
import store from './vuex/index'

//axios
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios)
axios.defaults.timeout = 600000
axios.interceptors.request.use(function (config) {
  config.params = {
    lang: process.env.LANG,
    ...config.params
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

//国际化
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh-hk', // 语言标识
  messages: {
    'zh-cn': require('./assets/js/zh-cn'), // 简体语言包
    'zh-hk': require('./assets/js/zh-hk'), // 繁体语言包
  },
});

//全局函数 权限编码
Vue.prototype.authority = function (power){
  return this.$store.state.Login.menus.indexOf(power) !== -1
};

//全局函数 加法运算，避免数据相加小数点后产生多位数和计算精度损失
Vue.prototype.numAdd=function (num1, num2) {
  let baseNum, baseNum1, baseNum2;
  num1 = num1 === undefined ? 0 : num1;
  num2 = num2 === undefined ? 0 : num2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}
//全局函数 减法运算，避免数据相加小数点后产生多位数和计算精度损失
Vue.prototype.numSub=function(num1, num2) {
  let baseNum, baseNum1, baseNum2;
  let precision;
  num1 = num1 === undefined ? 0 : num1;
  num2 = num2 === undefined ? 0 : num2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
};
//全局函数 乘法运算 避免数据相乘小数点后产生多位数和计算精度损失
Vue.prototype.numMulti=function (num1, num2) {
  let baseNum = 0;
  num1 = num1 === undefined ? 0 : num1;
  num2 = num2 === undefined ? 0 : num2;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {
  }
  return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
}
//全局函数 除法运算，避免数据相除小数点后产生多位数和计算精度损失
Vue.prototype.numDiv=function (num1, num2) {
  let baseNum1 = 0, baseNum2 = 0;
  let baseNum3, baseNum4;
  num1 = num1 === undefined ? 0 : num1;
  num2 = num2 === undefined ? 0 : num2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
}
//全局函数 success提示
Vue.prototype.openSucc=function(succ){
  this.$message({showClose: true, message: succ, type: 'success', duration:2000});
}
//全局函数 warning提示
Vue.prototype.openWar=function(err){
  this.$message({showClose: true, message: err, type: 'warning', duration:2000});
}
//全局函数 error提示
Vue.prototype.openErr=function(err){
  this.$message({showClose: true, message: err, type: 'error', duration:2000});
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  store,
  i18n,
})



// WEBPACK FOOTER //
// ./src/main.js